// Shows and hides header on scroll, and adds a class to the menu container when scrolled
window.addEventListener("scroll", () => {
  let header = document.querySelector("header.site-heading");
  let menu = header.querySelector(".menu-container");
  if (window.scrollY > 10) {
    menu.classList.add("transform");
  } else {
    menu.classList.remove("transform");
  }
});

window.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".impact-setting-text-wrapper")) {
    document.querySelector(
      ".impact-setting-text-wrapper"
    ).parentElement.parentElement.style.padding = "0";
  }
});

//Removing us-only classed elements if the country is not US
window.addEventListener("DOMContentLoaded", removeFreeShipping);
async function removeFreeShipping() {
  const response = await fetch(
    window.Shopify.routes.root + "browsing_context_suggestions.json"
  );
  const responseJson = await response.json();
  const responseCountry = responseJson.detected_values.country.handle;
  const windowCountry = window.Shopify.country;
  if (responseCountry == windowCountry && responseCountry == "US") {
    return;
  }
  const changeClass = "us-only";
  const elements = document.querySelectorAll(`.${changeClass}`);
  if (elements.length === 0) return;
  elements.forEach((element) => {
    element.remove();
  });
}
//Utility function, finds the value of a key in a nested object
function findValueByKey(object, key) {
  let value;
  Object.keys(object).some(function (k) {
    if (k.toLowerCase() === key.toLowerCase()) {
      value = object[k];
      return true;
    }
    if (object[k] && typeof object[k] === "object") {
      value = findValueByKey(object[k], key);
      return value !== undefined;
    }
  });
  return value;
}
//Utility function scrolls to the top of the page
function goTop() {
  window.scrollTo(0, 0);
}
//Utility function, toggles intercom chat
function openIntercom() {
  Intercom("showNewMessage");
}
//Utility function, disables scrolling on the body (used for modals)
function modalDisableScroll() {
  console.log("modalDisableScroll");
  const body = document.body;
  const html = document.querySelector("html");
  const heading = document.querySelector("header.site-heading");
  const floatingTools = document.querySelector(".floating-right-tools");
  floatingTools.style.zIndex = "0";
  heading.style.zIndex = "0";
  html.style.overflow = "hidden";
  body.style.overflow = "hidden";
}
//Utility function, enables scrolling on the body (used for modals)
function modalEnableScroll() {
  console.log("modalEnableScroll");
  var body = document.body;
  const html = document.querySelector("html");
  const heading = document.querySelector("header.site-heading");
  const floatingTools = document.querySelector(".floating-right-tools");
  body.style.overflow = "auto";
  html.style.overflow = "auto";
  floatingTools.style.zIndex = "5";
  heading.style.zIndex = "10";
  // body.style.paddingRight = "0";
}
//Utility function, captures escape key press and closes modals
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
//Utility function, adds debounce function for inputs
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
//Utility function, updates the cart number in the header when an item is added or removed
function updateCartNumber(number = null) {
  const cartNumber = document.querySelector(".cart-numbers");
  if (cartNumber) {
    cartNumber.textContent = number;
    if (number > 0) {
      cartNumber.style.visibility = "visible";
    } else {
      cartNumber.style.visibility = "hidden";
    }
  }
}
//PRODUCT SCRIPTS
class ComparePage extends HTMLElement {
  constructor() {
    super();
    this.params = this.getProductHandles();
    this.sectionId = this.id;
    this.seeMoreButton = this.querySelector(".see-more-button");
    this.seeMoreButton.addEventListener("click", () => {
      this.seeMore();
    });
    this.init();
    setTimeout(() => {
      const removeButtons = this.querySelectorAll(".remove-product");
      removeButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          const handle = e.currentTarget.dataset.handle;
          this.removeProduct(handle);
        });
      });
    }, 5000);
  }
  init() {
    // Add 4 way grid if 3 products are compared
    if (this.params.length === 2) {
      this.querySelector(".static-product-compare").classList.add(
        "three-products"
      );
    }
    // Show empty state if no products selected;
    if (this.params.length === 0) {
      this.querySelector(".compare-product.empty-product").classList.remove(
        "hidden"
      );
    }
    // Fetch and inject products;
    this.params.forEach(async (handle) => {
      await this.fetchProductByHandle(handle, this.sectionId);
    });
  }
  fetchProductByHandle(handle, sectionId) {
    fetch(`/products/${handle}?section_id=${sectionId}`, {
      view: "compare",
    })
      .then((res) => res.text())
      .then((data) => {
        const resultsMarkup = new DOMParser().parseFromString(
          data,
          "text/html"
        );
        const product = resultsMarkup.querySelector(
          `[data-handle="${handle}"]`
        );
        this.querySelector(".static-product-compare").appendChild(product);
      });
  }
  getProductHandles() {
    const searchParams = new URL(window.location).searchParams.get("compare");
    if (!searchParams) return;
    return searchParams.split(",");
  }
  seeMore() {
    const descriptions = this.querySelectorAll(".compare-description");
    if (this.seeMoreButton.classList.contains("active")) {
      descriptions.forEach((description) => {
        description.style.height = "120px";
        description.classList.remove("active");
      });
      this.seeMoreButton.classList.remove("active");
      this.seeMoreButton.innerHTML = window.comparePage.seeMore;
    } else {
      const maxHeight = Math.max(
        ...Array.from(descriptions).map(
          (description) => description.scrollHeight
        )
      );
      descriptions.forEach((description) => {
        description.style.height = `${maxHeight}px`;
        description.classList.add("active");
      });
      this.seeMoreButton.classList.add("active");
      this.seeMoreButton.innerHTML = window.comparePage.seeLess;
    }
  }
  removeProduct(handle) {
    const productContainer = this.querySelector(
      `.compare-product[data-handle='${handle}']`
    );
    productContainer.remove();
    const compareContainer = this.querySelector(".static-product-compare");
    const productNumber =
      compareContainer.querySelectorAll(".compare-product").length;
    if (productNumber == 3) {
      compareContainer.classList.remove("three-products");
    } else if (productNumber == 2) {
      this.querySelector(".compare-product.empty-product").classList.remove(
        "hidden"
      );
    } else if (productNumber < 2) {
      window.location.href = "/";
    }
  }
}
class RestockingDate extends HTMLElement {
  constructor() {
    super();
    this.dateString = this.dataset.date;
    if (this.dateString == "default") {
      this.date = new Date();
      this.date = this.date.setDate(this.date.getDate() + 28);
    } else {
      const year = "20" + this.dateString[0] + this.dateString[1];
      const month = this.dateString[2] + this.dateString[3];
      const day = this.dateString[4] + this.dateString[5];
      this.date = new Date(+year, month - 1, +day);
    }
    this.render();
  }
  render() {
    const currentDate = new Date();
    const diff = this.date - currentDate;
    const days = Math.floor(diff / 1000 / 60 / 60 / 24);
    if (days <= 7) {
      this.parentElement.classList.remove("restock");
      this.parentElement.classList.add("available");
      this.parentElement.innerHTML = window.restockDate.available;
    } else if (days <= 15) {
      this.innerHTML = window.restockDate.seventen;
    } else if (days <= 28) {
      this.innerHTML = window.restockDate.lesstwentyeight;
    } else {
      this.innerHTML = window.restockDate.plusthirty;
    }
  }
}
class DeliveryCountdown extends HTMLElement {
  constructor() {
    super();
    this.countdownContainer = this.querySelector(".text-countdown");
    this.year = this.countdownContainer.getAttribute("countdown-year");
    this.month = this.countdownContainer.getAttribute("countdown-month");
    this.days = this.countdownContainer.getAttribute("countdown-day");
    this.time = this.countdownContainer.getAttribute("countdown-time");
    this.timezone = this.countdownContainer.getAttribute("countdown-timezone");
    this.offset = this.countdownContainer.getAttribute("countdown-offset");
    this.locale = this.countdownContainer.getAttribute("countdown-locale");
    this.restockingDate = this.countdownContainer.getAttribute(
      "countdown-restocking-date"
    );
    this.specialOrder = this.countdownContainer.getAttribute(
      "countdown-special-order"
    );
    this.deliveryTime = this.querySelector(".delivery-time");
    this.dateObj = new Date(
      `${this.year}-${this.month}-${this.days}T${this.time}:00${this.timezone}`
    );
    this.hoursContainer = this.querySelector('[countdown-unit="hours"] div h3');
    this.minutesContainer = this.querySelector(
      '[countdown-unit="minutes"] div h3'
    );
    this.createCountdown();
  }
  createCountdown() {
    setInterval(() => {
      const now = new Date();
      const offsetDate = new Date();
      offsetDate.setDate(offsetDate.getDate() + parseInt(this.offset));
      if (this.restockingDate !== null) {
        const year = "20" + this.restockingDate[0] + this.restockingDate[1];
        const month = this.restockingDate[2] + this.restockingDate[3];
        const day = this.restockingDate[4] + this.restockingDate[5];
        const additionalOffset = new Date(+year, month - 1, +day) - now;
        const additionalDays = Math.floor(
          additionalOffset / 1000 / 60 / 60 / 24
        );
        offsetDate.setDate(offsetDate.getDate() + additionalDays);
      } else if (this.specialOrder === "true") {
        offsetDate.setDate(offsetDate.getDate() + 28);
      }
      if (offsetDate.getDay() === 0) {
        offsetDate.setDate(offsetDate.getDate() + 1);
      } else if (offsetDate.getDay() === 6) {
        offsetDate.setDate(offsetDate.getDate() + 2);
      }
      this.deliveryTime.textContent = offsetDate.toLocaleDateString(
        this.locale,
        {
          weekday: "long",
          month: "short",
          day: "numeric",
        }
      );
      const diff = this.dateObj - now;
      const days = Math.floor(diff / 1000 / 60 / 60 / 24);
      const hours = Math.floor(diff / 1000 / 60 / 60) % 24;
      const minutes = Math.floor(diff / 1000 / 60) % 60;
      const seconds = Math.floor(diff / 1000) % 60;
      if (this.daysContainer) {
        this.daysContainer.innerHTML = days.toString().padStart(2, "0");
      }
      if (this.hoursContainer) {
        this.hoursContainer.innerHTML = hours.toString().padStart(2, "0");
      }
      if (this.minutesContainer) {
        this.minutesContainer.innerHTML = minutes.toString().padStart(2, "0");
      }
    }, 1000);
  }
}
class OfferCountdown extends HTMLElement {
  constructor() {
    super();
    this.countdownContainer = this.querySelector(".countdown-container");
    this.year = this.countdownContainer.getAttribute("countdown-year");
    this.month = this.countdownContainer.getAttribute("countdown-month");
    this.days = this.countdownContainer.getAttribute("countdown-day");
    this.time = this.countdownContainer.getAttribute("countdown-time");
    this.timezone = this.countdownContainer.getAttribute("countdown-timezone");
    this.dateObj = new Date(
      `${this.year}-${this.month}-${this.days}T${this.time}:00${this.timezone}`
    );
    this.daysContainer = this.querySelector('[countdown-unit="days"] div h3');
    this.hoursContainer = this.querySelector('[countdown-unit="hours"] div h3');
    this.minutesContainer = this.querySelector(
      '[countdown-unit="minutes"] div h3'
    );
    this.secondsContainer = this.querySelector(
      '[countdown-unit="seconds"] div h3'
    );
    this.createCountdown();
  }
  createCountdown() {
    setInterval(() => {
      const now = new Date();
      const diff = this.dateObj - now;
      const days = Math.floor(diff / 1000 / 60 / 60 / 24);
      const hours = Math.floor(diff / 1000 / 60 / 60) % 24;
      const minutes = Math.floor(diff / 1000 / 60) % 60;
      const seconds = Math.floor(diff / 1000) % 60;
      if (this.daysContainer) {
        this.daysContainer.innerHTML = days.toString().padStart(2, "0");
      }
      if (this.hoursContainer) {
        this.hoursContainer.innerHTML = hours.toString().padStart(2, "0");
      }
      if (this.minutesContainer) {
        this.minutesContainer.innerHTML = minutes.toString().padStart(2, "0");
      }
      if (this.secondsContainer) {
        this.secondsContainer.innerHTML = seconds.toString().padStart(2, "0");
      }
    }, 1000);
  }
}
class TechSpecs extends HTMLElement {
  constructor() {
    super();
    this.techSpecJson = JSON.parse(
      this.querySelector('[type="application/json"]').innerText
    );
    this.initTables();
  }
  initTables() {
    Object.keys(this.techSpecJson).forEach((key) => {
      const table = document.createElement("table");
      table.classList.add("tech-specs");
      const title = document.createElement("caption");
      title.innerHTML = key;
      table.appendChild(title);
      const tbody = document.createElement("tbody");
      Object.keys(this.techSpecJson[key]).forEach((spec) => {
        const tr = document.createElement("tr");
        const th = document.createElement("th");
        th.innerHTML = spec;
        const td = document.createElement("td");
        td.innerHTML = this.techSpecJson[key][spec];
        tr.appendChild(th);
        tr.appendChild(td);
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      this.appendChild(table);
    });
  }
}
class AuthorizedModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector(".authorized-modal");
    this.tick = this.querySelector(".badge-icon");
    this.closeIcon = this.querySelector(".modal-header__close");

    this.tick.addEventListener("click", this.openModal.bind(this));
    this.closeIcon.addEventListener("click", this.closeModal.bind(this));
    this.modal.addEventListener("click", (event) => {
      if (event.target === this.modal) {
        this.closeModal();
      }
    });
  }
  openModal() {
    this.modal.classList.add("active");
    modalDisableScroll();
  }
  closeModal() {
    this.modal.classList.remove("active");
    modalEnableScroll();
  }
}
class GetAQuote extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.inputFields = {
      name: this.querySelector("#first-name"),
      phone: window.intlTelInput(this.querySelector("#phone"), {
        initialCountry: "US",
        showSelectedDialCode: true,
        strictMode: true,
        utilsScript:
          "https://cdn.jsdelivr.net/npm/intl-tel-input@21.2.7/build/js/utils.js",
      }),
      email: this.querySelector("#email"),
      message: this.querySelector("#message"),
      terms: this.querySelector("#terms"),
    };
    this.submitButton = this.querySelector("[type='submit']");
    // this.submitButton.addEventListener('click', async (e) => {
    //   e.preventDefault();
    //   const errors = this.validateForm();
    //   if(errors.length > 0){
    //     console.log(errors);
    //   } else {
    //     const response = await this.makeRequest();
    //     console.log(response);
    //     // this.form.submit();
    //   }
    // })
  }
  // async makeRequest(){
  //   const headers = new Headers();
  //   headers.append("Content-Type", "application/json");
  //   headers.append("Authorization", "Bearer N3VkWDdnT0xwemlCNjdjbzFPUkxxUGVqRG1XTElzck15ODNT");

  //   const url = "https://api.attentivemobile.com/v1/subscriptions"

  //   const rawData = JSON.stringify({
  //     "user": {
  //       "phone": this.inputFields.phone.getNumber(window.intlTelInputUtils.numberFormat.E164),
  //       "email": this.inputFields.email.value
  //     },
  //     "externalIdentifiers": {
  //       "customIdentifiers": [
  //         {
  //           "name": "Name",
  //           "value": this.inputFields.name.value
  //         },
  //         {
  //           "name": "Message",
  //           "value": this.inputFields.message.value
  //         }
  //       ]
  //     },
  //     "locale": {
  //       "language": "en",
  //       "country": "US"
  //     },
  //     "subscriptionType": "MARKETING",
  //   })
  //   const requestOptions = {
  //     method: 'POST',
  //     headers: headers,
  //     body: rawData,
  //     redirect: 'follow'
  //   };
  //   const response = await fetch(url, requestOptions);
  //   const data = await response.json();
  //   return data;
  // }
  // validateForm(){
  //   const errors = [];
  //   Object.keys(this.inputFields).forEach((key)=>{
  //     if(key === 'terms' && !this.inputFields[key].checked){
  //       errors.push(key);
  //     } else
  //     if(key === 'email' && !this.inputFields[key].value.includes('@')){
  //       errors.push(key);
  //     } else
  //     if(key === 'phone' && !this.inputFields[key].isValidNumber()){
  //       errors.push(key);
  //     } else
  //     if(this.inputFields[key].value === ""){
  //       errors.push(key);
  //     }
  //   })
  //   return errors;
  // }
}
class MetaVariants extends HTMLElement {
  constructor() {
    super();
    // Parse product variant data from the meta-info element
    this.variantJson = JSON.parse(
      this.querySelector(".meta-info").innerText
    ).products;
    // Precompute all valid option combinations for quick lookups
    this.variantCombinationSet = new Set(
      this.variantJson.map((variant) => variant.options.join(","))
    );
    // Remove component if there's only one variant (no selection needed)
    if (this.variantJson.length < 2) {
      this.remove();
    }
    // Get all variant selection buttons
    this.variantButtons = this.querySelectorAll(".meta-variant");
    // Get current product variant ID from data attribute
    this.currentVariantID = this.dataset.product;
    // Find the current variant object from the variant JSON
    this.currentVariant = this.variantJson.find((variant) => {
      if (variant.id == this.currentVariantID) {
        return variant;
      }
    });
    // Handle multi-option variants (like size, color, etc.)
    if (this.dataset.single != "true") {
      // Display selected options and mark active buttons
      this.currentVariant.options.forEach((option, index) => {
        this.querySelectorAll(".meta-variants__label__selected")[
          index
        ].textContent = option;
        this.variantButtons.forEach((button) => {
          if (button.dataset.option == option) {
            button.classList.add("active");
          }
        });
      });
      // Sort variant options for better display
      this.sortVariantOptions();
    } else {
      // Handle single-option variants (direct product selection)
      this.variantButtons.forEach((button) => {
        if (button.dataset.handle == this.currentVariant.handle) {
          button.classList.add("active");
        }
      });
      // Add part numbers to buttons for identification
      this.addPartNumbers();
    }
    // Add click event listeners to all variant buttons
    this.variantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        // Prevent re-selecting the already active button
        if (button.classList.contains("active")) return;
        // Update active button state
        button.parentElement
          .querySelector(".active")
          .classList.remove("active");
        button.classList.add("active");
        // Change variant based on selection
        if (button.dataset.handle) {
          this.changeVariant(button.dataset.handle);
        } else {
          this.detectVariant(button.dataset.option);
        }
      });
    });
    // Check which options are available/unavailable
    this.checkAvailability();
    // Setup part number selection if available
    if (
      this.dataset.single != "true" &&
      this.variantJson[0].partNumber != undefined
    ) {
      const dupes = this.getDuplicates();
      this.renderPartNumbers(dupes);
      this.addEventListenersToPart();
    }
  }

  /**
   * Natural sort function for alphanumeric strings
   * Sorts strings containing numbers in a human-readable way
   * e.g. "Option 2" will come before "Option 10"
   */
  naturalSort(a, b) {
    var ax = [],
      bx = [];
    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
      ax.push([$1 || Infinity, $2 || ""]);
    });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
      bx.push([$1 || Infinity, $2 || ""]);
    });
    while (ax.length && bx.length) {
      var an = ax.shift();
      var bn = bx.shift();
      var nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
      if (nn) return nn;
    }
    return ax.length - bx.length;
  }

  /**
   * Sort variant options in each category using natural sort
   * Ensures options like sizes or colors appear in logical order
   */
  sortVariantOptions() {
    const categories = this.querySelectorAll(".meta-variant-category");
    categories.forEach((category) => {
      const buttons = category.querySelectorAll(".meta-variant");
      const sortedButtons = Array.from(buttons).sort((a, b) => {
        return this.naturalSort(a.dataset.option, b.dataset.option);
      });
      sortedButtons.forEach((button) => {
        category.querySelector(".meta-variants__container").appendChild(button);
      });
    });
  }

  /**
   * Add part numbers to variant buttons
   * Appends the part number after the variant name for easier identification
   */
  addPartNumbers() {
    this.variantButtons.forEach((button) => {
      const partNumber = this.variantJson.find(
        (variant) => variant.handle == button.dataset.handle
      ).partNumber;
      console.log(partNumber);
      button.textContent = button.textContent + ` | ${partNumber}`;
    });
  }

  /**
   * Add click event listeners to part number elements
   * Allows users to select variants by clicking on part numbers
   */
  addEventListenersToPart() {
    const partNumbers = this.querySelectorAll(".meta-variant__part-number");
    partNumbers.forEach((partNumber) => {
      partNumber.addEventListener("click", (e) => {
        this.variantJson.forEach((variant) => {
          if (variant.id == e.currentTarget.dataset.option) {
            this.changeVariant(variant.handle);
          }
        });
      });
    });
  }

  /**
   * Render part numbers as selectable options
   * Creates and appends part number elements to the DOM
   * @param {Array} duplicates - Array of variant objects with duplicate options
   */
  renderPartNumbers(duplicates) {
    const category = document.createElement("div");
    category.classList.add("meta-variant-category");
    const title = document.createElement("p");
    title.innerHTML = `Part Number: `;
    title.classList.add("meta-variants__label");
    const partNumber = document.createElement("strong");
    category.appendChild(title);

    const partNumberContainer = document.createElement("ul");
    partNumberContainer.classList.add("meta-variants__container");
    duplicates.forEach((variant) => {
      const button = document.createElement("li");
      button.classList.add("meta-variant__part-number");
      button.innerHTML = variant.partNumber;
      button.dataset.option = variant.id;
      if (variant.id == this.currentVariantID) {
        button.classList.add("active");
        partNumber.innerText = variant.partNumber;
        title.appendChild(partNumber);
      }
      partNumberContainer.appendChild(button);
    });
    category.appendChild(partNumberContainer);
    this.appendChild(category);
  }

  /**
   * Get variants with identical option combinations
   * Identifies products that differ only by part number
   * @returns {Array} Array of variant objects with matching options
   */
  getDuplicates() {
    const currentOptions = this.currentVariant.options;
    const duplicates = this.variantJson.filter((variant) => {
      return variant.options.join(",") === currentOptions.join(",");
    });
    return duplicates;
  }

  /**
   * Check if current variant has duplicates
   * @returns {Boolean} Whether there are other variants with identical options
   */
  checkDuplicates() {
    const currentOptions = this.currentVariant.options;
    const isThereADuplicate = this.variantJson.some((variant) => {
      return (
        variant.options.join(",") === currentOptions.join(",") &&
        variant.id !== this.currentVariantID
      );
    });
    return isThereADuplicate;
  }

  /**
   * Check availability of variant options
   * Marks options as unavailable if they don't form valid combinations
   * with currently selected options in other categories
   */
  checkAvailability() {
    const activeOptions = Array.from(
      this.querySelectorAll(".meta-variant.active")
    ).map((button) => button.dataset.option);
    const optionsByCategory = this.querySelectorAll(
      ".meta-variants__container"
    );
    for (let j = 0; j < optionsByCategory.length; j++) {
      for (let k = 0; k < optionsByCategory[j].children.length; k++) {
        const button = optionsByCategory[j].children[k];
        if (button.classList.contains("active")) continue;
        if (button.classList.contains("unavailable")) continue;
        const optionCopy = [...activeOptions];
        optionCopy[j] = button.dataset.option;
        if (!this.variantCombinationSet.has(optionCopy.join(","))) {
          button.classList.add("unavailable");
        }
      }
    }
  }

  /**
   * Detect the most appropriate variant based on a changed option
   * Finds the variant that best matches current selections after one option changes
   * @param {String} changedOption - The newly selected option value
   */
  detectVariant(changedOption) {
    let activeOptions = [];
    this.variantButtons.forEach((button) => {
      if (button.classList.contains("active")) {
        activeOptions.push(button.dataset.option);
      }
    });
    let availableVariants = [];
    this.variantJson.forEach((variant) => {
      if (variant.options.includes(changedOption)) {
        availableVariants.push(variant);
      }
    });
    let variantSimilarities = {};
    availableVariants.forEach((variant) => {
      let matches = 0;
      activeOptions.forEach((option) => {
        if (variant.options.includes(option)) {
          matches++;
        }
      });
      variantSimilarities[variant.id] = matches;
    });
    let mostSimilarVariantID = Object.keys(variantSimilarities).reduce(
      (a, b) => {
        return variantSimilarities[a] > variantSimilarities[b] ? a : b;
      }
    );
    let mostSimilarVariant = this.variantJson.find((variant) => {
      return variant.id == mostSimilarVariantID;
    });
    this.changeVariant(mostSimilarVariant.handle);
  }

  /**
   * Change displayed product to the selected variant
   * Fetches and updates page content for the new variant
   * @param {String} variant - The product handle for the selected variant
   */
  changeVariant(variant) {
    const changeQueries = [
      ".product .breadcrumb",
      ".product .product-container",
      ".section-container .tab-container"
    ];
    const variantUrl = `/products/${variant}`;
    // this.loader.classList.add("active");
    fetch(`${variantUrl}`)
      .then((res) => res.text())
      .then((data) => {
        const resultsMarkup = new DOMParser().parseFromString(
          data,
          "text/html"
        );
        changeQueries.forEach((query) => {
          const results = resultsMarkup.querySelector(query);
          const current = document.querySelector(query);
          current.innerHTML = results.innerHTML;
        });
        window.history.pushState(
          { url: variantUrl },
          resultsMarkup.title,
          variantUrl
        );
        document.title = resultsMarkup.title;
        document.querySelector(".tab-container").init();
        rerunIframeResizerScript();
      });
  }
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector(
      "pickup-availability-container"
    );
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const rightPriceSource = html.querySelector(".info-right .right-price");
        const rightPriceDestination = document.querySelector(
          ".info-right .right-price"
        );

        if (rightPriceSource && rightPriceDestination) {
          rightPriceDestination.innerHTML = rightPriceSource.innerHTML;
        }

        const mediaSource = html.getElementById(
          `media-gallery-${this.dataset.section}`
        );
        const mediaGallery = document.getElementById(
          `media-gallery-${this.dataset.section}`
        );

        if (mediaSource && mediaGallery) {
          mediaGallery.innerHTML = mediaSource.innerHTML;
          mediaGallery.init();
        }

        const lightboxSource = html.getElementById(
          `lightbox-${this.dataset.section}`
        );
        const lightboxTarget = document.getElementById(
          `lightbox-${this.dataset.section}`
        );

        if (lightboxSource && lightboxTarget) {
          lightboxTarget.innerHTML = lightboxSource.innerHTML;
          lightboxTarget.init();
        }

        const quantitySource = html.getElementById(
          `Quantity-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const quantityDestination = document.getElementById(
          `Quantity-${this.dataset.section}`
        );

        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );
        const pickupSource = html.getElementById(
          `Pickup-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const pickupDestination = document.getElementById(
          `Pickup-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }
        if (quantitySource && quantityDestination) {
          quantityDestination.max = quantitySource.max;
          quantityDestination.min = quantitySource.min;
        }
        if (pickupSource && pickupDestination) {
          pickupDestination.innerHTML = pickupSource.innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("disabled-button");
      if (text) addButtonText.textContent = window.variantStrings.soldOut;
    } else {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("disabled-button");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}


// Function to rerun the iframeResizer script
function rerunIframeResizerScript() {
  // Remove any existing script element with the same source to ensure it reloads
  const existingScripts = document.querySelectorAll('script[src*="iframeResizer.js"]');
  existingScripts.forEach(script => {
    script.remove();
  });

  // Create new script element
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = '//content.etilize.com/apps/spexaccess/resources/js/iframeResizer.js';
  
  // Add onload handler to reinitialize iframeResizer if needed
  script.onload = function() {
    // console.log('iframeResizer script has been reloaded');
    
    // If the script creates a global function, reinitialize it
    if (typeof window.iFrameResize === 'function') {
      window.iFrameResize({
        log: false, // Set to true for debugging
        heightCalculationMethod: 'bodyOffset' // Or other method as needed
      }, 'iframe'); // Target selector for iframes you want to resize
    }
  };
  
  // Append to document head
  document.head.appendChild(script);
}
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
class PickupModal extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.pickupModalButton = this.querySelector(
      ".pickup-availability-information__button"
    );
    this.pickupModalButton.addEventListener(
      "click",
      this.toggleModal.bind(this)
    );
    this.pickupModal = this.querySelector(".pickup-availabilities-modal");
    this.closeButton = this.pickupModal.querySelector(
      ".pickup-availabilities-modal__close"
    );
    this.closeButton.addEventListener("click", this.toggleModal.bind(this));
  }
  toggleModal() {
    this.pickupModal.classList.toggle("active");
  }
}
class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.mediaGallery = this.querySelector(".image-gallery");
    this.mediaGalleryThumbs = this.querySelectorAll(".image-gallery__icon");
    this.mediaContainer = this.querySelector(".image-container");
    this.mediaList = this.querySelectorAll(".media-container");
    this.mediaGalleryThumbs.forEach((thumb) => {
      thumb.addEventListener("click", this.handleThumbClick.bind(this));
    });
    this.mediaList.forEach((media) => {
      if (media.children[0].nodeName === "IMG") {
        media.addEventListener("click", this.openLightBox.bind(this));
      }
    });
    this.mediaId = this.mediaGalleryThumbs[0].dataset.index;
  }
  handleThumbClick(e) {
    this.mediaId = e.currentTarget.dataset.index;
    this.mediaGalleryThumbs.forEach((thumb) => {
      if (thumb.dataset.index === this.mediaId) {
        thumb.classList.add("active");
      } else {
        thumb.classList.remove("active");
      }
    });
    this.mediaList.forEach((media) => {
      if (media.dataset.index === this.mediaId) {
        media.classList.add("active");
      } else {
        media.classList.remove("active");
      }
    });
  }
  openLightBox(e) {
    const lightbox = this.querySelector("light-box");
    lightbox.openLightBox(this.mediaId);
    modalDisableScroll();
  }
}
class LightBox extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.addEventListener("click", (e) => {
      if (e.target === this) {
        this.closeLightBox();
      }
    });
    this.mediaId = 0;
    this.lightboxImage = this.querySelector(".lightbox__image");
    this.lightboxGallery = this.querySelector(".lightbox__gallery__container");
    this.gallery = this.querySelectorAll(".lightbox__gallery__icon");
    this.images = this.querySelectorAll(".lightbox__image__media");
    // this.zoomFigures = this.querySelectorAll("figure.zoom");
    this.swiper = new Swiper(this.lightboxImage, {
      slidesPerView: 1,
      spaceBetween: 30,
      on: {
        slideChange: () => {
          this.mediaId = this.swiper.activeIndex;
          this.gallery.forEach((thumb) => {
            thumb.classList.remove("active");
            if (thumb.dataset.index == this.mediaId) {
              thumb.classList.add("active");
              thumb.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
              });
            }
          });
        },
      },
    });
    this.gallery.forEach((thumb) => {
      thumb.addEventListener("click", this.handleClick.bind(this));
    });
    this.images.forEach((image) => {
      image.addEventListener("mousemove", this.handleMouseMove.bind(this));
    });
    // this.zoomFigures.forEach((figure) => {
    //   figure.addEventListener("click", this.toggleZoom.bind(this));
    // });
    this.querySelector(".lightbox__close").addEventListener(
      "click",
      this.closeLightBox.bind(this)
    );
    this.querySelectorAll(".lightbox__nav").forEach((nav) => {
      if (nav.dataset.hasOwnProperty("prev")) {
        nav.addEventListener("click", this.previousImage.bind(this));
      } else if (nav.dataset.hasOwnProperty("next")) {
        nav.addEventListener("click", this.nextImage.bind(this));
      }
    });
  }
  openLightBox(mediaId) {
    this.classList.add("active");
    this.dataset.enabled = true;
    this.keydownFunction = this.handleKeyDown.bind(this);
    window.addEventListener("keydown", this.keydownFunction);
    this.changeImage(mediaId);
    // this.zoomFigures.forEach((figure) => {
    //   figure.classList.remove("active");
    // });
  }
  handleKeyDown(e) {
    if (this.dataset.enabled) {
      e.preventDefault();
      if (e.keyCode === 27 /* ESC */) {
        this.closeLightBox();
      }
      if (e.keyCode === 37 /* LEFT */) {
        this.previousImage();
      }
      if (e.keyCode === 39 /* RIGHT */) {
        this.nextImage();
      }
    }
  }
  handleClick(e) {
    let target = e.target;
    if (e.target.tagName === "IMG") {
      target = e.target.parentNode;
    }
    const eventIndex = target.dataset.index;
    this.changeImage(eventIndex);
  }
  closeLightBox() {
    this.classList.remove("active");
    this.dataset.enabled = false;
    window.removeEventListener("keydown", this.keydownFunction);
    modalEnableScroll();
  }
  nextImage() {
    if (this.mediaId < this.images.length - 1) {
      this.changeImage(parseInt(this.mediaId) + 1);
    } else {
      this.changeImage(0);
    }
  }
  previousImage() {
    if (this.mediaId > 0) {
      this.changeImage(parseInt(this.mediaId) - 1);
    } else {
      this.changeImage(this.images.length - 1);
    }
  }
  changeImage(id) {
    this.mediaId = id;
    this.gallery.forEach((thumb) => {
      if (thumb.dataset.index == id && !thumb.classList.contains("active")) {
        thumb.classList.add("active");
        thumb.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      } else {
        thumb.classList.remove("active");
      }
    });
    this.swiper.slideTo(id);
  }
  handleMouseMove(e) {
    const image = e.target;
    const imageWidth = image.offsetWidth;
    const imageHeight = image.offsetHeight;
    const mouseX = e.offsetX;
    const mouseY = e.offsetY;
    const percentX = mouseX / imageWidth;
    const percentY = mouseY / imageHeight;
    const transformX = percentX * 100;
    const transformY = percentY * 100;
    image.style.backgroundPosition = transformX + "% " + transformY + "%";
  }
  toggleZoom(e) {
    const figure = e.currentTarget;
    figure.classList.toggle("active");
  }
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("complementary-slider") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
class ComplementarySlider extends HTMLElement {
  constructor() {
    super();
    this.columns = this.dataset.columns;
    this.initSlider();
  }
  initSlider() {
    this.swiper = new Swiper(this, {
      slidesPerView: this.columns,
      spaceBetween: 15,
    });
  }
}
class PageNavigator extends HTMLElement {
  constructor() {
    super();
    this.next = this.querySelector(".page-navigator__next");
    this.previous = this.querySelector(".page-navigator__previous");
    this.swiperWrapper = this.querySelector(".extra-wrapper");
    this.swiper = new Swiper(this.swiperWrapper, {
      slidesPerView: 3,
      spaceBetween: 8,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: this.next,
        prevEl: this.previous,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 32,
        },
      },
      on: {
        resize: () => {
          if (this.swiper.allowSlideNext) {
            this.next.style.display = "flex";
          } else {
            this.next.style.display = "none";
          }
          if (this.swiper.allowSlidePrev) {
            this.previous.style.display = "flex";
          } else {
            this.previous.style.display = "none";
          }
        },
        init: () => {
          this.querySelector(".swiper-wrapper").style.gap = "0px";
          this.querySelector(".swiper-wrapper").style.justifyContent =
            "flex-start";
        },
      },
    });
  }
}
class TimelineScroller extends HTMLElement {
  constructor() {
    super();
    this.timelineContainer = this.querySelector(".timeline-container");
    this.timelinePaginator = this.querySelector(".timeline-paginator");
    this.timelineLabels = this.querySelectorAll(
      ".timeline-labels .timeline-label"
    );
    this.swiper = new Swiper(this.timelineContainer, {
      autoHeight: true,
      slidesPerView: "auto",
      pagination: {
        el: this.timelinePaginator,
        clickable: true,
        type: "progressbar",
      },
      on: {
        slideChange: () => {
          this.timelineLabels.forEach((label) => {
            label.classList.remove("active");
          });
          this.timelineLabels[this.swiper.activeIndex].classList.add("active");
        },
      },
    });
    this.timelineLabels.forEach((label, index) => {
      label.addEventListener("click", () => {
        this.swiper.slideTo(index);
      });
    });
  }
}
class SectionNavigator extends HTMLElement {
  constructor() {
    super();
    this.toggler = this.querySelector(".section-navigator__title");
    this.linkContainer = this.querySelector(".section-navigator__container");
    this.toggler.addEventListener("click", this.toggleNavigator.bind(this));
  }
  toggleNavigator() {
    if (window.innerWidth < 1280) {
      if (this.linkContainer.classList.contains("active")) {
        this.linkContainer.style.maxHeight = "0px";
      } else {
        this.linkContainer.style.maxHeight =
          this.linkContainer.scrollHeight + 32 + "px";
      }
      this.linkContainer.classList.toggle("active");
    }
  }
}
class QuantityContainer extends HTMLElement {
  constructor() {
    super();
    this.quantity = this.querySelector(".quantity");
    this.decrementButton = this.querySelector(
      "[data-quantity-button='decrement']"
    );
    this.incrementButton = this.querySelector(
      "[data-quantity-button='increment']"
    );
    this.max = this.quantity.max;
    this.min = this.quantity.min;
    this.incrementButton.addEventListener(
      "click",
      this.incrementCart.bind(this)
    );
    this.decrementButton.addEventListener(
      "click",
      this.decrementCart.bind(this)
    );
    this.quantity.addEventListener("change", this.quantityUpdate.bind(this));
    this.quantity.addEventListener("input", this.quantityUpdate.bind(this));
  }
  quantityUpdate(e) {
    this.checkQuantity();
  }
  incrementCart(el) {
    this.quantity.value = parseInt(this.quantity.value) + 1;
    this.checkQuantity();
  }
  decrementCart(el) {
    this.quantity.value = parseInt(this.quantity.value) - 1;
    this.checkQuantity();
  }
  checkQuantity() {
    if (this.max != "") {
      if (parseInt(this.quantity.value) > this.max) {
        this.quantity.value = this.max;
      }
    }
    if (this.min != "") {
      if (parseInt(this.quantity.value) < this.min) {
        this.quantity.value = this.min;
      }
    }
  }
}
class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.buttons = this.querySelectorAll(".button-container__button");
    this.tabs = this.querySelectorAll(".tab-text");
    this.border = this.querySelector(".tab-button-border");
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.handleTabClick.bind(this));
    });
    this.changeTab(0);
    window.addEventListener("resize", this.adjustBorder.bind(this));
  }
  handleTabClick(e) {
    const button = e.target;
    this.buttons.forEach((button) => {
      button.classList.remove("active");
    });
    this.tabs.forEach((tab) => {
      if (tab.dataset.id === button.dataset.id) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });
    button.classList.add("active");
    this.adjustBorder();
  }
  changeTab(index) {
    this.buttons.forEach((button, _index) => {
      if (index == _index) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    });
    this.tabs.forEach((tab, _index) => {
      if (index == _index) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });
    this.adjustBorder();
  }
  adjustBorder() {
    let active = this.querySelector(".button-container__button.active");
    this.border.style.width = active.scrollWidth + "px";
    this.border.style.left = active.offsetLeft + "px";
  }
}
class KeyFeatures extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const condition = this.getHeight();
    // if (condition) {
    //   this.addSeeMore(condition);
    // } else {
    //   this.querySelector(".key-features__see-more").style.display = "none";
    // }
  }
  getHeight() {
    const keyHeight = this.offsetHeight;
    const leftHeight = document.querySelector(".info-left").offsetHeight;
    const rightHeight = 630;
    if (leftHeight > rightHeight) {
      const difference = leftHeight - rightHeight;
      const newHeight = keyHeight - difference;
      return newHeight;
    } else {
      return false;
    }
  }
  addSeeMore(height) {
    this.featureContainer = this.querySelector(".key-features__list");
    this.featureContainer.classList.add("see-more");
    this.featureContainer.style.maxHeight = height + "px";
    this.seeMoreButton = this.querySelector(".key-features__see-more");
    this.seeMoreButton.addEventListener("click", () => {
      if (this.featureContainer.classList.contains("see-more")) {
        this.featureContainer.classList.remove("see-more");
        this.featureContainer.style.maxHeight = "1000px";
        this.seeMoreButton.innerHTML = window.comparePage.seeLess;
        this.seeMoreButton.classList.add("active");
      } else {
        this.featureContainer.classList.add("see-more");
        this.featureContainer.style.maxHeight = height + "px";
        this.seeMoreButton.innerHTML = window.comparePage.seeMore;
        this.seeMoreButton.classList.remove("active");
      }
    });
  }
}
class DynamicComparison extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.comparisonInfo = JSON.parse(
      this.querySelector(".comparison-info").innerHTML
    );
    this.comparisonTableBody = this.querySelector("#comparison-table-body");
    this.productInfoFormatted = [];
    this.comparisonInfo.products.forEach((product) => {
      this.productInfoFormatted.push(this.getInfoByProduct(product));
    });
    this.productInfoFormatted = this.removeNAValues(this.productInfoFormatted);
    this.renderProductInfo();
  }
  getInfoByProduct(product) {
    const productInfo = {};
    this.comparisonInfo.featured_names.forEach((attribute) => {
      const foundAttribute = findValueByKey(product, attribute);
      if (foundAttribute !== undefined) {
        if (typeof foundAttribute === "object") {
          for (let key in foundAttribute) {
            productInfo[attribute] = foundAttribute[key];
          }
        } else if (typeof foundAttribute === "array") {
          productInfo[attribute] = foundAttribute.join(", ");
        } else {
          productInfo[attribute] = foundAttribute;
        }
      } else {
        productInfo[attribute] = "N/A";
      }
    });
    return productInfo;
  }
  renderProductInfo() {
    this.comparisonInfo.featured_names.forEach((attribute) => {
      if (this.productInfoFormatted[0][attribute] !== undefined) {
        const row = document.createElement("tr");
        const rowTitle = document.createElement("td");
        rowTitle.classList.add("comparison-table__row-title");
        rowTitle.innerHTML = attribute;
        row.appendChild(rowTitle);
        this.productInfoFormatted.forEach((product) => {
          const cell = document.createElement("td");
          cell.classList.add("comparison-table__row-cell");
          cell.innerHTML = product[attribute];
          row.appendChild(cell);
        });
        this.comparisonTableBody.appendChild(row);
      }
    });
  }
  removeNAValues(productInfo) {
    // Remove N/A values if all products have the same value
    const productInfoCopy = [...productInfo];
    const productInfoKeys = Object.keys(productInfo[0]);
    productInfoKeys.forEach((key) => {
      const values = productInfo.map((product) => product[key]);
      if (values.every((val) => val === values[0] && val === "N/A")) {
        productInfoCopy.forEach((product) => {
          delete product[key];
        });
      }
    });
    return productInfoCopy;
  }
}
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('[type="submit"]');
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
    this.messageWrapper = this.querySelector(".form-message");
  }
  handleSubmit(event) {
    event.preventDefault();

    const formConfig = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/javascript`,
      },
    };
    formConfig.headers["X-Requested-With"] = "XMLHttpRequest";
    delete formConfig.headers["Content-Type"];
    const formData = new FormData(this.form);
    formConfig.body = formData;

    fetch(`${routes.cart_add_url}`, formConfig)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.renderError(response);
        } else {
          this.messageWrapper.classList.add("active");
          this.messageWrapper.innerText = window.variantStrings.addedToCart;
          this.updateCart();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
  updateCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((response) => {
        if (document.querySelector(".cart-container .cart-numbers")) {
          if (response.item_count === 0) {
            document.querySelector(
              ".cart-container .cart-numbers"
            ).style.visibility = "hidden";
          } else {
            document.querySelector(
              ".cart-container .cart-numbers"
            ).style.visibility = "visible";
          }
          document.querySelector(".cart-container .cart-numbers").innerText =
            response.item_count;
        }
      });
  }
  renderError(response) {
    this.messageWrapper.classList.add("active");
    this.messageWrapper.innerText = response.description;
  }
}

// PRODUCT SCRIPTS END

// ACCOUNT SCRIPTS
class AddressContainer extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.addressBlocks = this.querySelectorAll(".customer-address");
    this.addressForms = this.querySelectorAll(".address-editor__container");
    this.addressBlocks.forEach((addressBlock) => {
      addressBlock
        .querySelector(".edit-address-button")
        .addEventListener(
          "click",
          this.changeAddressFormVisibility.bind(
            this,
            addressBlock.dataset.addressId
          )
        );
      addressBlock
        .querySelector(".delete-address-button")
        .addEventListener("click", (e) => {
          if (confirm("Are you sure you want to delete this address?")) {
            e.target.form.submit();
          }
        });
    });
    this.addressForms.forEach((addressForm) => {
      const country = addressForm.querySelector("[name='address[country]']");
      const province = addressForm.querySelector("[name='address[province]']");
      country.childNodes.forEach((countryOption) => {
        if (countryOption.value == country.dataset.default) {
          countryOption.selected = true;
        }
      });
      this.populateProvince(country, province);
      province.childNodes.forEach((provinceOption) => {
        if (provinceOption.value == province.dataset.default) {
          provinceOption.selected = true;
        }
      });
      this.querySelectorAll(".backtoadd-address-button").forEach((button) => {
        button.addEventListener("click", this.showNewAddressForm.bind(this));
      });
      country.addEventListener("change", this.handleCountryChange.bind(this));
    });
  }
  handleCountryChange(event) {
    const country = event.target;
    const province = country.parentElement.parentElement.querySelector(
      "[name='address[province]']"
    );
    this.populateProvince(country, province, true);
  }
  populateProvince(countryContainer, provinceContainer, onchange = false) {
    const provinceList = JSON.parse(
      countryContainer[countryContainer.selectedIndex].dataset.provinces
    );
    if (provinceList.length > 0) {
      provinceContainer.disabled = false;
      provinceContainer.innerHTML = "";
      provinceContainer.appendChild(new Option("Select a province", ""));
      provinceList.map((province) => {
        provinceContainer.appendChild(new Option(province[0], province[1]));
      });
    } else {
      provinceContainer.innerHTML = "";
      provinceContainer.appendChild(new Option("No province", ""));
      provinceContainer.children[0].selected = true;
      provinceContainer.selectedIndex = 0;
      provinceContainer.value = "";
      provinceContainer.disabled = true;
    }
  }
  changeAddressFormVisibility(addressId, event) {
    this.addressForms.forEach((addressForm) => {
      if (addressForm.dataset.addressId == addressId) {
        addressForm.classList.add("visible");
        addressForm.scrollIntoView({
          behavior: "smooth",
          inline: "nearest",
        });
      } else {
        addressForm.classList.remove("visible");
      }
    });
  }
  showNewAddressForm() {
    this.changeAddressFormVisibility("new");
  }
}
// ACCOUNT SCRIPTS END

// SECTION SCRIPTS
class MiniSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.nextButton = this.querySelector(".mini-slider__next");
    this.prevButton = this.querySelector(".mini-slider__prev");
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: "8",
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
    });
  }
}
class AgeGate extends HTMLElement {
  constructor() {
    super();
    this.minAge = this.getAttribute("age-minimum");
    this.input = this.querySelector("#dob_date");
    this.button = this.querySelector("#dob_button");
    this.error = this.querySelector(".age-gate__error");
    this.button.addEventListener("click", this.handleButtonClick.bind(this));
    this.checkAge();
  }
  checkAge() {
    let ageCheck = localStorage.getItem("age-pass");
    if (ageCheck || this.ageVerification) {
      this.remove();
    }
  }
  handleButtonClick() {
    const now = new Date();
    const birthDate = new Date(this.input.value);
    let age = now.getFullYear() - birthDate.getFullYear();
    let month = now.getMonth() - birthDate.getMonth();
    if (month < 0 || month == 0) {
      age--;
    }
    if (age >= this.minAge) {
      this.ageVerification = true;
      localStorage.setItem("age-pass", this.ageVerification);
    } else {
      this.error.style.display = "block";
      this.ageVerification = false;
      this.button.disabled = true;
    }
    this.checkAge();
  }
}
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener("click", (event) => {
      if (this.elements.button.getAttribute("aria-expanded") == "false") {
        this.openSelector();
        this.elements.button.setAttribute("aria-expanded", "true");
      } else {
        this.closeSelector();
        this.elements.button.setAttribute("aria-expanded", "false");
      }
    });
    this.elements.button.addEventListener("focusout", () => {
      setTimeout(() => {
        this.closeSelector();
        this.elements.button.setAttribute("aria-expanded", "false");
      }, 400);
    });
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    // this.elements.button.focus();
    this.querySelector(".disclosure__list").style.maxHeight = "250px";
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }

  closeSelector() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.querySelector(".disclosure__list").style.maxHeight = "0";
  }
}
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.year = this.getAttribute("countdown-year");
    this.month = this.getAttribute("countdown-month");
    this.day = this.getAttribute("countdown-day");
    this.time = this.getAttribute("countdown-time");
    this.timezone = this.getAttribute("countdown-timezone");
    this.dateObj = new Date(
      `${this.year}-${this.month}-${this.day}T${this.time}:00${this.timezone}`
    );
    this.daysContainer = this.querySelectorAll(
      '[countdown-unit="days"] div h3'
    );
    this.hoursContainer = this.querySelectorAll(
      '[countdown-unit="hours"] div h3'
    );
    this.minutesContainer = this.querySelectorAll(
      '[countdown-unit="minutes"] div h3'
    );
    this.createCountdown();
  }
  createCountdown() {
    let diff;
    let now;
    this.interval = setInterval(() => {
      now = new Date();
      diff = this.dateObj - now;
      const days = Math.floor(diff / 1000 / 60 / 60 / 24)
        .toString()
        .padStart(3, "0");
      const hours = (Math.floor(diff / 1000 / 60 / 60) % 24)
        .toString()
        .padStart(2, "0");
      const minutes = (Math.floor(diff / 1000 / 60) % 60)
        .toString()
        .padStart(2, "0");
      this.daysContainer[0].innerHTML = days[1];
      this.daysContainer[1].innerHTML = days[2];
      this.hoursContainer[0].innerHTML = hours[0];
      this.hoursContainer[1].innerHTML = hours[1];
      this.minutesContainer[0].innerHTML = minutes[0];
      this.minutesContainer[1].innerHTML = minutes[1];
    }, 1000);
  }
}
class MenuListItem extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector(".accordion-class");
    this.menu = this.querySelector(".menu-content");
    this.accordion.addEventListener("click", this.handleClick.bind(this));
  }
  handleClick() {
    this.menu.classList.toggle("active");
  }
}
class FAQAccordion extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.button = this.querySelector("button");
    this.content = this.querySelector(".faq-block__tab-content");
    this.buttonArrow = this.querySelector(".faq-block__tab-icon");
    this.button.addEventListener("click", () => {
      this.content.classList.toggle("hidden-tab");
      this.buttonArrow.classList.toggle("active-svg");
    });
  }
}
class TabCollage extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(".collapsable-tab");
    this.tabMedia = this.querySelectorAll(".tab-media");
    this.tabTitles = this.querySelectorAll(".collapsable-tab .tab-title");
    this.tabMedia[0].classList.add("active");
    this.tabs[0].classList.add("active");
    this.tabTitles.forEach((title) => {
      title.addEventListener("click", this.handleClick.bind(this));
    });
  }
  handleClick(event) {
    const target = event.target;
    const targetIndex = Array.from(this.tabTitles).indexOf(target);
    this.tabMedia.forEach((media, index) => {
      media.classList.remove("active");
      if (targetIndex == index) {
        media.classList.add("active");
      }
    });
    this.tabs.forEach((tab, index) => {
      tab.classList.remove("active");
      if (targetIndex == index) {
        tab.classList.add("active");
      }
    });
  }
}
class FeaturedSwiper extends HTMLElement {
  constructor() {
    super();
    if (document.dir != "rtl") {
      this.nextButton = this.querySelector(".nextButton");
      this.prevButton = this.querySelector(".prevButton");
    } else {
      this.nextButton = this.querySelector(".prevButton");
      this.prevButton = this.querySelector(".nextButton");
    }
    this.pagination = this.querySelector(".swiper-pagination");
    this.container = this.querySelector(".featured-swiper-container");
    this.wrapper = this.querySelector(".swiper-wrapper");
    this.swiper;
    this.swiperSettings = {
      slidesPerView: 2.2,
      spaceBetween: 12,
      loop: false,
      loopFillGroupWithBlank: false,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      pagination: {
        el: this.pagination,
        clickable: true,
      },
      breakpoints: {
        768: {},
        1024: {},
        1280: {},
        1440: {},
      },
      freeMode: true,
      freeModeMomentum: true,
      breakpoints: {
        768: {},
        1024: {},
        1280: {},
        1440: {},
      },
      on: {
        init: () => {
          this.wrapper.classList.remove("slider-placeholder");
        },
      },
    };

    if (this.dataset.block == "true") {
      this.swiperSettings.slidesPerView = 2.2;
      this.swiperSettings.breakpoints[768].slidesPerView = 3;
      this.swiperSettings.breakpoints[768].slidesPerGroup = 3;
      this.swiperSettings.breakpoints[1024].slidesPerView = 4;
      this.swiperSettings.breakpoints[1024].slidesPerGroup = 4;
      this.swiperSettings.breakpoints[1280].slidesPerView = 5;
      this.swiperSettings.breakpoints[1280].slidesPerGroup = 5;
      this.swiperSettings.breakpoints[1440].slidesPerView = 6;
      this.swiperSettings.breakpoints[1440].slidesPerGroup = 6;
    } else {
      this.swiperSettings.slidesPerView = 2.2;
      this.swiperSettings.breakpoints[768].slidesPerView = 5;
      this.swiperSettings.breakpoints[768].slidesPerGroup = 5;
      this.swiperSettings.breakpoints[1024].slidesPerView = 6;
      this.swiperSettings.breakpoints[1024].slidesPerGroup = 6;
      this.swiperSettings.breakpoints[1280].slidesPerView = 7;
      this.swiperSettings.breakpoints[1280].slidesPerGroup = 7;
      this.swiperSettings.breakpoints[1440].slidesPerView = 8;
      this.swiperSettings.breakpoints[1440].slidesPerGroup = 8;
    }

    if (this.dataset.style == "grid") {
      this.gridEventListener();
      if (window.innerWidth <= 768) {
        this.sliderInit();
      } else {
        if (this.dataset.block == "true") {
          this.wrapper.classList.add("block");
        }
        this.wrapper.classList.remove("slider-placeholder");
        this.wrapper.classList.add("grid");
        this.nextButton.style.visibility = "hidden";
        this.prevButton.style.visibility = "hidden";
        this.pagination.style.visibility = "hidden";
      }
    } else {
      this.wrapper.classList.remove("slider-placeholder");
      this.sliderInit();
    }
  }

  gridEventListener() {
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 768) {
        this.sliderInit();
      } else {
        this.sliderDestroy();
      }
    });
  }

  sliderInit() {
    if (this.swiper && this.swiper.destroyed == false) {
      return;
    }
    this.wrapper.classList.remove("grid");
    if (this.dataset.block == "true") {
      this.wrapper.classList.remove("block");
    }
    this.swiper = new Swiper(this.container, this.swiperSettings);
    this.swiper.destroyed = false;
    if (window.innerWidth <= 768) {
      this.nextButton.style.visibility = "hidden";
      this.prevButton.style.visibility = "hidden";
      this.pagination.style.visibility = "hidden";
    } else {
      this.nextButton.style.visibility = "visible";
      this.prevButton.style.visibility = "visible";
      this.pagination.style.visibility = "visible";
    }
  }

  sliderDestroy() {
    if (this.swiper != undefined) {
      if (this.swiper.destroyed == false) {
        this.swiper.destroy();
        if (this.dataset.block == "true") {
          this.wrapper.classList.add("block");
        }
        this.wrapper.classList.add("grid");
        this.nextButton.style.visibility = "hidden";
        this.prevButton.style.visibility = "hidden";
        this.pagination.style.visibility = "hidden";
      }
    }
  }
}
class VideoSlider extends HTMLElement {
  constructor() {
    super();
    this.pagination = this.querySelector(".swiper-pagination");
    this.thumbnails = [];
    this.getThumbnails();
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      updateOnWindowResize: true,
      pagination: {
        el: this.pagination,
        clickable: true,
        renderBullet: (index, className) => {
          return `<div class="${className}"><img src="${this.thumbnails[index]}" style="object-fit:cover; object-psoition:center;width: 3.5cqw; height: 3.5cqw; min-width:30px; min-height:30px; max-width:45px; max-height:45px; border-radius: 2.5px;"
          ></div>`;
        },
      },
    });
  }
  getThumbnails() {
    const videos = this.querySelectorAll(".lazy-video");
    const videoURLS = [];
    videos.forEach((video) => {
      videoURLS.push(video.dataset.src);
    });
    videoURLS.forEach((url) => {
      const thumbnailURL = this.checkThumbnailURL(url);
      this.thumbnails.push(thumbnailURL);
    });
  }
  checkThumbnailURL(url) {
    if (url.match(LazyVideo.YT_REGEX)) {
      const videoID = url.match(LazyVideo.YT_REGEX)[1];
      return `https://img.youtube.com/vi/${videoID}/sddefault.jpg`;
    } else if (url.match(LazyVideo.VIMEO_REGEX)) {
      const videoID = url.match(LazyVideo.VIMEO_REGEX)[1];
      return `https://vumbnail.com/${videoID}.jpg`;
    }
  }
}
class LazyVideo extends HTMLElement {
  static YT_REGEX =
    /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/;
  static VIMEO_REGEX = /^.*(?:vimeo.com\/|video\/)([^#&?]*).*/;
  constructor() {
    super();
    this.videoPlayBtn = this.querySelector(".video-play-btn");
    this.videoOverlay = this.querySelector(".video-overlay");
    this.videoURL = this.dataset.src;
    this.iFrame = document.createElement("iframe");
    this.videoPlayBtn.addEventListener("click", this.playVideo.bind(this));
    this.thumbnailURL = this.checkThumbnailURL(this.videoURL);
    this.thumbnail = document.createElement("img");
    this.thumbnail.src = this.thumbnailURL;
    this.videoOverlay.appendChild(this.thumbnail);
  }
  playVideo() {
    this.videoOverlay.style.display = "none";
    this.videoPlayBtn.style.display = "none";
    this.checkVideoURL(this.videoURL);
  }
  checkThumbnailURL(url) {
    if (url.match(LazyVideo.YT_REGEX)) {
      return `https://img.youtube.com/vi/${
        url.match(LazyVideo.YT_REGEX)[1]
      }/hqdefault.jpg`;
    } else if (url.match(LazyVideo.VIMEO_REGEX)) {
      return `https://i.vimeocdn.com/video/${
        url.match(LazyVideo.VIMEO_REGEX)[1]
      }_640.jpg`;
    } else {
      return false;
    }
  }
  checkVideoURL(url) {
    if (url.match(LazyVideo.YT_REGEX)) {
      this.createYoutubeVideo(url);
    } else if (url.match(LazyVideo.VIMEO_REGEX)) {
      this.createVimeoVideo(url);
    } else {
      return false;
    }
  }
  createYoutubeVideo(url) {
    this.iFrame.setAttribute(
      "src",
      `https://www.youtube.com/embed/${
        url.match(LazyVideo.YT_REGEX)[1]
      }?rel=0&mute=1&autoplay=1`
    );
    this.iFrame.setAttribute("allow", "autoplay");
    this.prepend(this.iFrame);
  }
  createVimeoVideo(url) {
    this.iFrame.setAttribute(
      "src",
      `https://player.vimeo.com/video/${
        url.match(LazyVideo.VIMEO_REGEX)[1]
      }?muted=1?autoplay=1`
    );
    this.iFrame.setAttribute("allow", "autoplay");
    this.prepend(this.iFrame);
  }
}
class MilestoneBlocks extends HTMLElement {
  constructor() {
    super();
    this.swiperSettings = {
      slidesPerView: 1.15,
      spaceBetween: 12,
      centeredSlides: true,
      loop: false,
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
        1280: {
          centeredSlides: false,
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    };
    this.swiper = new Swiper(this, this.swiperSettings);
  }
}
//SECTION SCRIPTS END

//HEADER SCRIPTS
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.nextButton = this.querySelector(".next-announcement");
    this.previousButton = this.querySelector(".prev-announcement");
    this.allAnnouncemenets = this.querySelectorAll(".announcement-text");
    this.allAnnouncemenets[0].classList.add("active");
    this.slideCount = this.allAnnouncemenets.length;
    this.activeIndex = 0;
    this.nextButton.addEventListener("click", this.nextSlide.bind(this));
    this.previousButton.addEventListener(
      "click",
      this.previousSlide.bind(this)
    );
    this.createInterval();
  }
  nextSlide() {
    this.clearInterval();
    if (this.activeIndex < this.slideCount - 1) {
      this.activeIndex++;
    } else {
      this.activeIndex = 0;
    }
    this.allAnnouncemenets.forEach((item, index) => {
      item.classList.remove("active");
      if (this.activeIndex == index) {
        item.classList.add("active");
      }
    });
    this.createInterval();
  }
  previousSlide() {
    this.clearInterval();
    if (this.activeIndex > 0) {
      this.activeIndex--;
    } else {
      this.activeIndex = this.slideCount - 1;
    }
    this.allAnnouncemenets.forEach((item, index) => {
      item.classList.remove("active");
      if (this.activeIndex == index) {
        item.classList.add("active");
      }
    });
    this.createInterval();
  }
  createInterval() {
    this.interval = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }
  clearInterval() {
    clearInterval(this.interval);
  }
}
class ShoppingCartModal extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector(".cart-link");
    this.modal = this.querySelector(".shopping-cart-modal");
    this.button.addEventListener("click", this.toggleModal.bind(this));
    this.updateCart();
  }
  toggleModal() {
    this.modal.classList.toggle("active");
  }
  updateCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => (this.data = data));
  }
}
//HEADER SCRIPTS END

//PRODUCT CARD START
class LimitedDeal extends HTMLElement {
  constructor() {
    super();
    this.year = this.getAttribute("countdown-year");
    this.month = this.getAttribute("countdown-month");
    this.day = this.getAttribute("countdown-day");
    this.time = this.getAttribute("countdown-time");
    this.timezone = this.getAttribute("countdown-timezone");
    this.dateObj = new Date(
      `${this.year}-${this.month}-${this.day}T${this.time}:00${this.timezone}`
    );
    this.createTimer();
  }
  createTimer() {
    let now;
    let diff;
    this.countdown = setInterval(() => {
      now = new Date();
      diff = this.dateObj - now;
      const days = Math.floor(diff / 1000 / 60 / 60 / 24);
      const hours = Math.floor(diff / 1000 / 60 / 60) % 24;
      const minutes = Math.floor(diff / 1000 / 60) % 60;
      const seconds = Math.floor(diff / 1000) % 60;
      this.querySelector('[countdown-unit="days"] div h3').innerHTML = days
        .toString()
        .padStart(2, "0");
      this.querySelector('[countdown-unit="hours"] div h3').innerHTML = hours
        .toString()
        .padStart(2, "0");
      this.querySelector('[countdown-unit="minutes"] div h3').innerHTML =
        minutes.toString().padStart(2, "0");
      this.querySelector('[countdown-unit="seconds"] div h3').innerHTML =
        seconds.toString().padStart(2, "0");
    }, 1000);
  }
}
class QuickShop extends HTMLElement {
  constructor() {
    super();
    this.url = `/products/${this.getAttribute("product-handle")}`;
    this.addEventListener("click", this.fetchQuickShop.bind(this));
  }
  fetchQuickShop() {
    const quickModal = document.querySelector("#quick-modal");
    quickModal.classList.remove("hidden");
    quickModal.querySelector("#quick-modal-content").innerHTML = "";
    quickModal.querySelector(".quickshop-skeleton").classList.remove("hidden");
    modalDisableScroll();
    fetch(this.url, { method: "GET" })
      .then((response) => response.text())
      .then((data) => {
        const resultsMarkup = new DOMParser().parseFromString(
          data,
          "text/html"
        );
        const productPage = resultsMarkup.getElementById(
          "productSection-product-template"
        );
        quickModal.querySelector(".quickshop-skeleton").classList.add("hidden");
        quickModal
          .querySelector("#quick-modal-content")
          .appendChild(productPage);
      });
  }
}
class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.productHandle = this.getAttribute("product-handle");
    if (this.productHandle == "") {
      return;
    }
    try {
      this.json = JSON.parse(
        this.parentElement.parentElement.querySelector(
          'script[type="application/json"]'
        ).innerHTML
      );
    } catch (error) {
      console.log(error);
      console.log(this);
    }

    this.variantId = this.json.variant_id;
    this.addEventListener("click", this.addToCart.bind(this));
  }
  addToCart() {
    const data = {
      items: [
        {
          id: this.variantId,
          quantity: 1,
        },
      ],
    };
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.text())
      .then((data) => {
        this.updateCartCount();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  updateCartCount() {
    const cartCount = document.querySelector(".cart-container .cart-numbers");
    if (!cartCount) return;
    fetch("/cart.js")
      .then((res) => res.json())
      .then((data) => {
        updateCartNumber(data.item_count);
      });
  }
}
class CompareButton extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.getAttribute("product-handle");
    this.input = this.querySelector(".compare-checkbox");

    if (this.productHandle == "") {
      return;
    }
    this.json = JSON.parse(
      this.parentElement.querySelector('script[type="application/json"]')
        .innerHTML
    );
    this.input.addEventListener("change", this.onCompareChange.bind(this));
  }
  onCompareChange() {
    this.classList.toggle("active");
    const compareList = JSON.parse(localStorage.getItem("compareList")) || [];
    if (this.input.checked) {
      if (compareList.length > 0) {
        compareList.forEach((item, index) => {
          if (item.handle == this.json.handle) {
            compareList.splice(index, 1);
          }
        });
      }
      if (compareList.length >= 3) {
        this.input.checked = false;
        return;
      } else {
        compareList.push(this.json);
        updateCompare(compareList);
      }
    } else {
      compareList.splice(compareList.indexOf(this.json), 1);
      updateCompare(compareList);
    }
  }
}

!(function (document) {
  var CarouselPlugin = function () {
    var plugin;
    var defaults = {
      wait: 4000,
      autoplay: true,
      selectors: {
        slideWrapper: ".banners",
        navigationDots: ".banner-nav-dots div",
      },
      animateIn: "animate_fadeIn",
      animateOut: "animate_fadeOut",
      isAutoWidth: false,
    };

    var element,
      $slideWrapper,
      $navigationDots,
      autoplay = autoplay,
      wait = wait,
      // TODO: animate classes can be removed and implemented like full width banner css
      // animateIn = 'animate_fadeIn', animateOut = 'animate_fadeOut',
      intervalId = undefined,
      current = 0,
      $slides,
      totalCount,
      totalImages,
      // When we begin, assume no images are loaded.
      imagesLoaded = 0;

    /*** Private Methods */
    var _slideShow = function () {
      _displaySlide(current);
      intervalId = setInterval(function () {
        _showNext(1);
      }, wait);
    };

    var _showCurrent = function (n) {
      _displaySlide((current = n));
    };

    var _showNext = function (n) {
      clearInterval(intervalId);
      if (n < 0) {
        _displaySlide((current -= 1));
      } else {
        _displaySlide((current += 1));
      }

      if (n === -1) {
        intervalId = setInterval(function () {
          _showNext(n + 2);
        }, wait);
      } else {
        intervalId = setInterval(function () {
          _showNext(n + 1);
        }, wait);
      }
    };

    var _displaySlide = function (n) {
      // Get the next index.  If at end, restart to the beginning.
      current = n >= totalCount ? 0 : n < 0 ? 1 : n;

      var $currentSlide = $slides.item(current),
        $currentDot = $navigationDots.item(current);

      for (var i = 0; i < $slides.length; i++) {
        var slide = $slides.item(i);
        if (!slide.isSameNode($currentSlide)) {
          slide.classList.add(plugin.options.animateOut);
          // Hide the previous
          slide.classList.remove("active", plugin.options.animateIn);
        }
      }

      for (var i = 0; i < $navigationDots.length; i++) {
        var navDot = $navigationDots.item(i);
        if (!navDot.isSameNode($currentDot)) {
          navDot.classList.remove("active");
        }
      }

      // Show the next
      $currentSlide.classList.add("active", plugin.options.animateIn);
      $currentDot.classList.add("active");
    };

    function _initBanner() {
      if (plugin.options.isAutoWidth) {
        _showBanner(false);
        _carouselNormalization();
      } else {
        $slideWrapper.classList.add("visible");
        element.dispatchEvent(new Event("available"));
      }
    }

    function _showBanner(show) {
      if (show) {
        $slideWrapper.classList.remove("invisible");
      } else {
        $slideWrapper.classList.add("invisible");
      }
    }

    // normalization function for Auto Width banner
    // TODO: can be implemented like full width with structural change of css
    function _carouselNormalization() {
      var heights = [], //create empty array to store height values
        tallest;

      if (totalCount) {
        attachEvents();

        function normalizeHeights() {
          var $imageContainer = [].filter.call($slides, function (slide) {
            return slide.querySelectorAll(".bg-image-holder");
          });

          $imageContainer.forEach(function (imgContainer) {
            //add heights to array
            heights.push(imgContainer.offsetHeight);
          });

          tallest = Math.max.apply(null, heights); //cache largest value

          /*  
                        banners height need to be specified 
                        Reason: because parent with relative position does not get height from its children which are absolute positioned 
                    */
          $slides.forEach(function (slide) {
            slide.style.minHeight = tallest + "px";
          });
          $slideWrapper.style.minHeight = tallest + "px";
          $slideWrapper.style.height = tallest + "px";
          _showBanner(true);

          element.dispatchEvent(new Event("available"));
        }

        function resetHeightAndRecalculate() {
          (tallest = 0), (heights.length = 0); //reset vars
          $slides.forEach(function (slide) {
            slide.style.minHeight = "";
          });

          $slideWrapper.style.minHeight = "";
          $slideWrapper.style.height = "";

          normalizeHeights(); //run it again
        }

        function attachEvents() {
          // attach event on img load, once all images are loaded, heights can be calculated
          // this event will be triggered for number of images in the banner

          $slideWrapper.querySelectorAll("img").forEach(function (image) {
            image.addEventListener("load", function (event) {
              imagesLoaded++;
              if (imagesLoaded == totalImages) {
                // all images loaded
                normalizeHeights();
              }
            });
            if (image.complete) {
              // hack to trigger load explicitly if image is loaded even before the load event was attached to it
              image.dispatchEvent(new Event("load"));
            }
          });

          function _windowResizeHandler(event) {
            if (element) {
              resetHeightAndRecalculate();
            }
          }

          // if window is resized or orientation is changed, recalculate height
          window.addEventListener("resize", _windowResizeHandler);
          window.addEventListener("orientationchange", _windowResizeHandler);
        }
      }
    }

    /*** Register plugin in window object */
    var Carousel = function (options) {
      plugin = this;

      plugin.options =
        options && typeof options === "object"
          ? _extendDefaults(defaults, options)
          : defaults;

      element = plugin.options.element;
      ($slideWrapper =
        $slideWrapper ||
        element.querySelectorAll(plugin.options.selectors.slideWrapper)[0]),
        ($navigationDots =
          $navigationDots ||
          element.querySelectorAll(plugin.options.selectors.navigationDots)),
        (autoplay = plugin.options.autoplay),
        (wait = plugin.options.wait),
        // TODO: animate classes can be removed and implemented like full width banner css
        // plugin.options.animateIn = 'animate_fadeIn', plugin.options.animateOut = 'animate_fadeOut',
        (intervalId = undefined),
        (current = 0);

      (plugin.options.isAutoWidth = element.matches(".auto-width")),
        ($slides = element.querySelectorAll(".slide")),
        (totalCount = $slides.length),
        (totalImages = [].filter.call($slides, function (el) {
          return el.querySelectorAll("img");
        }).length);

      // When we begin, assume no images are loaded.
      imagesLoaded = 0;

      plugin.init();
    };

    /*** Public Methods */

    Carousel.prototype.stop = function () {
      if (!intervalId) {
        return;
      }
      clearInterval(intervalId);
      intervalId = undefined;
    };

    Carousel.prototype.start = function () {
      plugin.stop();
      // intervalId = setInterval(_slideShow, wait);
      _slideShow();
    };

    Carousel.prototype.init = function () {
      var plugin = this;

      function _navigationHandler() {
        var slideNumber = parseInt(this.getAttribute("data-number"));
        _displaySlide(slideNumber - 1);
      }

      function _availableHandler(event) {
        if (plugin.options.autoplay) plugin.start();
      }

      // start: attach carousel events
      element.addEventListener("mouseenter", function (event) {
        if (plugin.options.autoplay) plugin.stop();
      });
      element.addEventListener("available", _availableHandler);
      element.addEventListener("mouseleave", _availableHandler);

      $navigationDots.forEach(function (navDot) {
        navDot.removeEventListener("click", _navigationHandler);
      });
      $navigationDots.forEach(function (navDot) {
        navDot.addEventListener("click", _navigationHandler);
      });
      // end: attach carousel events
      _initBanner();
    };

    return {
      create: function (options) {
        return new Carousel(options);
      },
    };
  };

  function _extendDefaults(defaults, properties) {
    var extended = {};

    // Loop through obj1
    for (var prop1 in defaults) {
      if (defaults.hasOwnProperty(prop1)) {
        // Push each value from `defaults` into `extended`
        extended[prop1] = defaults[prop1];
      }
    }

    // Loop through obj2
    for (var prop2 in properties) {
      if (properties.hasOwnProperty(prop2)) {
        // Push each value from `properties` into `extended`
        extended[prop2] = properties[prop2];
      }
    }

    return extended;
  }

  function _documentReady(fn) {
    // Sanity check
    if (typeof fn !== "function") return;

    // If document is already loaded, run method
    if (document.readyState === "complete") {
      return fn();
    }

    // Otherwise, wait until document is loaded
    document.addEventListener("DOMContentLoaded", fn, false);
  }

  _documentReady(function () {
    document
      .querySelectorAll(".rc-template-rotating-banner")
      .forEach(function (el) {
        if (undefined == el.getAttribute("data-carousel")) {
          var cp = new CarouselPlugin();
          var plugin = cp.create({
            element: el,
          });
          // el.setAttribute('data-carousel', plugin);
        }
      });
  });
})(document);
//PRODUCT CARD END

class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.submitButton = this.querySelector(".search-button.search-header");
    this.searchForm = this.querySelector("form");
    this.inputField = this.querySelector("input#search-header");

    this.submitButton.addEventListener("click", this.submitSearch.bind(this));
  }
  submitSearch(event) {
    event.preventDefault();
    if (this.inputField.value.trim().length < 2) return;
    this.searchForm.submit();
  }
}
class HeroSlider extends HTMLElement {
  constructor() {
    super();

    const renderButton = this.renderPagination;
    const container = this.querySelector(".swiper-container");
    const pagination = this.querySelector(".swiper-pagination");
    const slides = this.querySelectorAll(".swiper-slide");
    //Swiper Settings
    const sliderEffect = this.dataset.effect;
    const paginationStyle = this.dataset.pagination;
    const autoplay = this.dataset.autoplay;
    const autoplayDelay = this.dataset.autoplayDelay * 1000;
    //Navigation

    let previousButton;
    let nextButton;

    if (document.dir != "rtl") {
      previousButton = this.querySelector(".swiper__button-prev");
      nextButton = this.querySelector(".swiper__button-next");
    } else {
      previousButton = this.querySelector(".swiper__button-next");
      nextButton = this.querySelector(".swiper__button-prev");
    }

    // Optimize images before initializing Swiper for better LCP
    this.optimizeImages(slides);

    this.swiperSettings = {
      loop: true,
      updateOnWindowResize: true,
      speed: 300,
      slidesPerView: 1,
      // Preload images for better performance
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: true
      },
      pagination: {
        el: pagination,
        clickable: true,
        bulletClass: "swiper-custom-bullet",
        bulletActiveClass: "swiper-custom-bullet-active",
        renderBullet: function (index, className) {
          return renderButton(index, className, slides, paginationStyle);
        },
      },
      // Initialize only when visible to avoid competing with LCP
      observer: true,
      observeParents: true
    };

    if (previousButton && nextButton) {
      this.swiperSettings.navigation = {
        nextEl: nextButton,
        prevEl: previousButton,
      };
    }
    if (autoplay == "true") {
      this.swiperSettings.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      };
    }
    if (sliderEffect == "fade") {
      this.swiperSettings.effect = "fade";
      this.swiperSettings.fadeEffect = {
        crossFade: true,
      };
    }

    // Use IntersectionObserver to initialize Swiper only when needed
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.initSwiper(container);
          observer.disconnect();
        }
      }, { threshold: 0.1 });
      
      observer.observe(this);
    } else {
      // Fallback for browsers without IntersectionObserver
      this.initSwiper(container);
    }
  }

  initSwiper(container) {
    if (!this.swiper) {
      this.swiper = new Swiper(container, this.swiperSettings);
      
      // Listen for slide transitions to optimize offscreen slides
      this.swiper.on('slideChangeTransitionEnd', () => {
        this.optimizeVisibleSlides();
      });
    }
  }

  optimizeImages(slides) {
    // Properly handle the first slide for LCP
    if (slides.length > 0) {
      const firstSlideImg = slides[0].querySelector('img.swiper-slide__desktop-image');
      if (firstSlideImg) {
        // Ensure first slide image loads eagerly for LCP
        firstSlideImg.loading = 'eager';
        firstSlideImg.fetchpriority = 'high';
        
        // If it has data attributes, move them to the actual attributes
        if (firstSlideImg.dataset.src) {
          firstSlideImg.src = firstSlideImg.dataset.src;
          firstSlideImg.removeAttribute('data-src');
        }
        if (firstSlideImg.dataset.srcset) {
          firstSlideImg.srcset = firstSlideImg.dataset.srcset;
          firstSlideImg.removeAttribute('data-srcset');
        }
        
        // Add explicit width and height to prevent CLS
        if (!firstSlideImg.hasAttribute('width') && firstSlideImg.naturalWidth) {
          firstSlideImg.setAttribute('width', firstSlideImg.naturalWidth);
        }
        if (!firstSlideImg.hasAttribute('height') && firstSlideImg.naturalHeight) {
          firstSlideImg.setAttribute('height', firstSlideImg.naturalHeight);
        }
      }
    }
    
    // Properly set up remaining slides for lazy loading
    for (let i = 1; i < slides.length; i++) {
      const img = slides[i].querySelector('img.swiper-slide__desktop-image');
      if (img) {
        // Ensure proper lazy loading for non-first slides
        img.loading = 'lazy';
        img.classList.add('irvine-lazy');
        
        // Make sure it has alt text for accessibility
        if (!img.alt || img.alt === 'Slide') {
          img.alt = `Slide ${i + 1}`;
        }
      }
    }
  }
  
  optimizeVisibleSlides() {
    if (!this.swiper) return;
    
    // Get the current active slide and next/prev slides
    const activeIndex = this.swiper.activeIndex;
    const slides = this.swiper.slides;
    
    // Make sure all images in the current view are loaded
    const visibleIndices = [
      activeIndex,
      this.swiper.isBeginning ? slides.length - 1 : activeIndex - 1,
      this.swiper.isEnd ? 0 : activeIndex + 1
    ];
    
    visibleIndices.forEach(index => {
      const slide = slides[index];
      if (!slide) return;
      
      const img = slide.querySelector('img.swiper-slide__desktop-image');
      if (!img) return;
      
      // If it's still using data-src, move to src for visible slides
      if (img.dataset.src && !img.src) {
        img.src = img.dataset.src;
      }
      if (img.dataset.srcset && !img.srcset) {
        img.srcset = img.dataset.srcset;
      }
    });
  }

  renderPagination(index, className, slides, style) {
    if (style == "dot") {
      return `<span class="${className}"></span>`;
    } else if (style == "number") {
      return `<span class="${className}">${index + 1}</span>`;
    } else if (style == "img") {
      const image = slides[index].querySelector("img.swiper-slide__desktop-image");
      const imageUrl = image && image.dataset.navImage ? image.dataset.navImage : '';
      return `<span class="${className}"><img src="${imageUrl}" alt="slide-${index + 1}" loading="lazy" width="64" height="40"></span>`;
    }
  }
}

//DEFINITIONS START
customElements.define("hero-slider", HeroSlider);
customElements.define("header-search", HeaderSearch);
customElements.define("mini-slider", MiniSlider);
customElements.define("milestone-blocks", MilestoneBlocks);
customElements.define("product-form", ProductForm);
customElements.define("key-features", KeyFeatures);
customElements.define("get-a-quote", GetAQuote);
customElements.define("compare-page", ComparePage);
customElements.define("restocking-date", RestockingDate);
customElements.define("dynamic-comparison", DynamicComparison);
customElements.define("timeline-scroller", TimelineScroller);
customElements.define("section-navigator", SectionNavigator);
customElements.define("shopping-cart-modal", ShoppingCartModal);
customElements.define("lazy-video", LazyVideo);
customElements.define("video-slider", VideoSlider);
customElements.define("featured-swiper", FeaturedSwiper);
customElements.define("tab-collage", TabCollage);
customElements.define("page-navigator", PageNavigator);
customElements.define("limited-deal", LimitedDeal);
customElements.define("quick-shop", QuickShop);
customElements.define("add-to-cart", AddToCart);
customElements.define("compare-button", CompareButton);
customElements.define("delivery-countdown", DeliveryCountdown);
customElements.define("offer-countdown", OfferCountdown);
customElements.define("pickup-modal", PickupModal);
customElements.define("product-tabs", ProductTabs);
customElements.define("quantity-container", QuantityContainer);
customElements.define("complementary-slider", ComplementarySlider);
customElements.define("product-recommendations", ProductRecommendations);
customElements.define("media-gallery", MediaGallery);
customElements.define("light-box", LightBox);
customElements.define("variant-selects", VariantSelects);
customElements.define("variant-radios", VariantRadios);
customElements.define("address-container", AddressContainer);
customElements.define("age-gate", AgeGate);
customElements.define("localization-form", LocalizationForm);
customElements.define("countdown-timer", CountdownTimer);
customElements.define("menu-list-item", MenuListItem);
customElements.define("faq-accordion", FAQAccordion);
customElements.define("announcement-bar", AnnouncementBar);
customElements.define("meta-variants", MetaVariants);
customElements.define("tech-specs", TechSpecs);
customElements.define("authorized-modal", AuthorizedModal);
// DEFINITIONS END
